import React from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import { FormGroup, FormControl, Button, ControlLabel } from 'react-bootstrap';
import '../../../components/search-bar/SearchBar.css';

class SearchBarTelefonos extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      selector_value: props.opciones[0].value,
      placeholder: props.opciones[0].desc,
      //numberOnly: props.opciones[0].numberOnly,
      caracteristica: '',
      numero: '',
      completo: ''
    }
  }

  selectorOnChange = (event) => {
    let option = find(this.props.opciones, (item) => item.value === event.target.value);
    this.setState({
      selector_value: option.value,
      placeholder: option.desc,
      numberOnly: option.numberOnly,
      caracteristica: '',
      numero: '',
    });
  }

  handleSubmit = () => {
    if (this.state.caracteristica.length === 0 || this.state.numero.length === 0) {
      return;
    }
    
      let calculado = '';
      calculado = `0${this.state.caracteristica}${this.state.numero}`;

    this.props.onBusqueda(this.state.selector_value, calculado);

  }

  onChangeTextNumero = (ev) => {
    let value = ev.target.value;
    if (this.state.numberOnly === true) {
      let regNumber = /^\d*$/g;
      if (!regNumber.test(value))
        return;
    }

    this.setState({ numero: value });
  }

  onChangeTextCaracteristica = (ev) => {
    let value = ev.target.value;
    if (this.state.numberOnly === true) {
      let regNumber = /^\d*$/g;
      if (!regNumber.test(value))
        return;
    }

    this.setState({ caracteristica: value });
  }

  handleEnterPress = (ev) => {
    if (ev.key === 'Enter') {
      this.handleSubmit();
    }
  }

  mapOptions = (array) => {
    return array.map((opt, ix) =>
      <option key={ix} value={opt.value}>{opt.desc}</option>
    );
  }

  render() {
    return (
      <div>
        <div className="searchbar-form -telefonos">
            <FormGroup className="search-selector">
                <FormControl componentClass="select" onChange={this.selectorOnChange} value={this.state.selector_value}>
                    {this.mapOptions(this.props.opciones)}
                </FormControl>
            </FormGroup>

            <FormGroup className="search-text" onChange={this.onChangeTextCaracteristica}>
                <ControlLabel>0</ControlLabel>
                <FormControl placeholder="Caracteristica " value={this.state.caracteristica} onKeyPress={this.handleEnterPress}>
                </FormControl>
            </FormGroup>
            <FormGroup className="search-text" onChange={this.onChangeTextNumero}>
                { this.state.selector_value === 'cel' &&
                    <ControlLabel>15</ControlLabel>
                }
                <FormControl placeholder="Número" value={this.state.numero} onKeyPress={this.handleEnterPress}>
                </FormControl>
            </FormGroup>

            <div className="search-button">
                <Button onClick={this.handleSubmit} bsStyle="primary" className={(this.state.caracteristica.length === 0 || this.state.numero.length === 0) ? 'disabled' : ''} >
                    Buscar
                </Button>
            </div>
        </div>
    </div>
    )
  }
}

SearchBarTelefonos.propTypes = {
    opciones: PropTypes.array,
    onBusqueda: PropTypes.func
}

export default SearchBarTelefonos;



// WEBPACK FOOTER //
// ./src/scenes/telefonos/components/SearchBarTelefonos.js